import type { CSSProperties } from "react";
import React, { PureComponent } from "react";

interface IconProps {
  name: string;
  label?: string;
  height?: number;
  width?: number;
  size?: number;
  className?: string;
  key?: number;
  style?: CSSProperties;
  color?: string;
  stroke?: string;
}

class Icon extends PureComponent<IconProps> {
  public override render() {
    const props = { ...this.props };

    const href = `#icon-${props.name}`;

    const aria = props.label
      ? { "aria-label": props.label }
      : { "aria-hidden": "true" as const };
    const color = props.color || "currentColor";

    if (props.size && !props.width && !props.height) {
      props.width = props.size;
      props.height = props.size;
      delete props.size;
    }

    return (
      <svg fill={color} {...props} preserveAspectRatio="xMidYMid meet">
        <use xlinkHref={href} href={href} {...aria} />
      </svg>
    );
  }
}

export default Icon;
